import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { doLogin } from "../shared/store/actions/login";
import Login from "../components/Configurator/Login";

const withAuth = WrappedComponent => {
  class HOC extends Component {
    render() {
      if (!this.props.authenticated) {
        return <Login onLogin={this.props.doLogin} />;
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  return HOC;
};

const mapStateToProps = state => ({
  authenticated: state.app.isWired
});

const composedWithUser = compose(
  connect(
    mapStateToProps,
    { doLogin }
  ),
  withAuth
);

export default composedWithUser;
